module.exports = __webpack_public_path__ + "fonts/SFUIText-BoldItalic.f910c8b9.ttf";